import Vue from 'vue'
import Vuex from 'vuex'
import { alert } from './store/alert.module';
import { users } from './store/users.module';
import { boards } from './store/boards.module';
import { characters } from './store/characters.module';
import { coachingSessions } from './store/coachingSessions.module';
import { groups } from './store/groups.module';
import { heros } from './store/heros.module';
import { keyValues } from './store/keyValues.module';
import { notes } from './store/notes.module';
import { settings } from './store/settings.module';
import { spaces } from './store/spaces.module';
import { staticInfos } from './store/staticInfos.module';
import { variations } from './store/variations.module';
import { messages } from './store/messages.module';


Vue.use(Vuex)

const state = {
  sidebarShow: 'responsive',
  sidebarMinimize: false
}

const mutations = {
  toggleSidebarDesktop (state) {
    const sidebarOpened = [true, 'responsive'].includes(state.sidebarShow)
    state.sidebarShow = sidebarOpened ? false : 'responsive'
  },
  toggleSidebarMobile (state) {
    const sidebarClosed = [false, 'responsive'].includes(state.sidebarShow)
    state.sidebarShow = sidebarClosed ? true : 'responsive'
  },
  set (state, [variable, value]) {
    state[variable] = value
  }
}

export default new Vuex.Store({
  namespaced: true,
  state,
  mutations,
  modules: {alert,users,boards,characters,coachingSessions,groups,heros,keyValues,notes,settings,spaces,staticInfos,variations, messages}
});